module.exports = __webpack_public_path__ + "static/googleplay.5c598965.png";